export default __webpack_public_path__ + "static/media/joshua-stannard.9cf11297.jpg";